import React from 'react';

export default class Desktop1Big3SmallHorizontal extends React.Component {
  render() {
    return (
      <div className="row mb-3 pb-3">
        <div className="col-lg-12 pb-3 mb-4">
          <img src={this.props.big} alt="project"/>
        </div>
        <div className="col-lg-4">
          <img src={this.props.small1} alt="project"/>
        </div>
        <div className="col-lg-4">
          <img src={this.props.small2} alt="project"/>
        </div>
        <div className="col-lg-4">
          <img src={this.props.small3} alt="project"/>
        </div>
      </div>
    );
  }
};
